import { yupResolver } from '@hookform/resolvers/yup';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import AllocationDeletePublicHolidayFormDefaultValue from 'components/allocations/AllocationPublicHoliday/AllocationDeletePublicHoliday/AllocationDeletePublicHolidayFormDefaultValue';
import AllocationDeletePublicHolidayValidation from 'components/allocations/AllocationPublicHoliday/AllocationDeletePublicHoliday/AllocationDeletePublicHolidayValidation';
import StyledForm from 'components/sharedComponents/StyledForm/StyledForm';
import { Controller, FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { logError } from 'shared/errorHandling/ErrorToast/errorHandling';
import { RootState } from 'store';
import deletePublicHoliday from 'store/action/allocationsAction/deletePublicHoliday';
import { useAppSelector, useThunkAppDispatch } from 'store/redux-hooks/hooks';
import AllocationDeletePublicHolidayFormDto from 'types/allocation/dto/allocationPublicHolidayDto/AllocationDetelePublicHolidayFormDto';
import AllocationDeleteFormNames from 'types/allocation/enums/AllocationDeleteFormComponentsName';
import ButtonsText from 'types/generalEnums/ButtonsText';
import CustomModalButtons from 'components/sharedComponents/CustomModalButton/CustomModalButton';
import useEscapeKey from 'store/customHooks/useEscapeKey';

type AllocationDeletePublicHolidayFormProps = {
  onCloseDeleteWindow: (isSubmitted: boolean) => void;
};

const AllocationDeletePublicHolidayForm = ({
  onCloseDeleteWindow
}: AllocationDeletePublicHolidayFormProps) => {
  const dispatch = useThunkAppDispatch();
  const dbid = useAppSelector((state: RootState) => state.allocationPublicHoliday.data.id);
  useEscapeKey(() => {
    onCloseDeleteWindow(false);
  });
  const methods = useForm({
    defaultValues: AllocationDeletePublicHolidayFormDefaultValue(dbid),
    // TODO fix unknown
    resolver: yupResolver(
      AllocationDeletePublicHolidayValidation()
    ) as unknown as Resolver<AllocationDeletePublicHolidayFormDto>
  });
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = methods;

  const onSubmit: SubmitHandler<AllocationDeletePublicHolidayFormDto> = async (
    data: AllocationDeletePublicHolidayFormDto
  ) => {
    try {
      await dispatch(deletePublicHoliday(data)).unwrap();
      onCloseDeleteWindow(true);
    } catch (error) {
      logError('Error deleting public holiday');
    }
  };

  return (
    <FormProvider {...methods}>
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} className="modal-container">
          <Grid item xs={12} md={12}>
            <p className="inter-p3 delete-descriotion">
              {AllocationDeleteFormNames.DeletePublicHolidayTitle}
            </p>
          </Grid>
          <Grid item xs={12} md={12}>
            <Controller
              name={AllocationDeleteFormNames.DeletePublicHolidayName}
              control={control}
              render={({ field }) => (
                <FormControl>
                  <RadioGroup
                    name={AllocationDeleteFormNames.DeletePublicHolidayName}
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      control={<Radio />}
                      label={AllocationDeleteFormNames.DeletePublicHolidayFirstLabel}
                      value={false}
                      className="delete-radio-button delete-radio-button-first"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      label={AllocationDeleteFormNames.DeletePublicHolidaySecondLabel}
                      value
                      className="delete-radio-button "
                    />
                  </RadioGroup>
                  {errors && (
                    <span className="error-message">
                      {errors.deleteAllHolidaysThisDay?.message}
                    </span>
                  )}
                </FormControl>
              )}
            />
          </Grid>
        </Grid>
        <CustomModalButtons
          submitButtonText={ButtonsText.Delete}
          isCancelButtonVisible
          submitButtonClassName="add-button"
          onClick={() => onCloseDeleteWindow(false)}
        />
      </StyledForm>
    </FormProvider>
  );
};

export default AllocationDeletePublicHolidayForm;
